/* SAINE · Accueil premium : apparition au scroll + rails horizontaux */
(function () {
  if (window.__spm) return;
  window.__spm = true;
  document.documentElement.classList.add('spm-js');

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function initReveal(root) {
    root.querySelectorAll('.spm-rv:not(.is-in)').forEach(function (el, i) {
      if (!io) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = (el.dataset.d || 0) + 'ms';
      io.observe(el);
    });
  }

  function initRails(root) {
    root.querySelectorAll('[data-spm-rail]').forEach(function (rail) {
      if (rail.__spm) return;
      rail.__spm = true;
      var track = rail.querySelector('.spm-track');
      var prev = rail.querySelector('[data-spm-prev]');
      var next = rail.querySelector('[data-spm-next]');
      if (!track) return;
      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var nav = rail.querySelector('.spm-nav');
        if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) { initReveal(root || document); initRails(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
